import { AfterViewInit, Component, Input, OnInit, input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { KeywordsComponent, KeywordItemComponent, ExpandableComponent, HtmlEscapePipe } from '@exl-ng/mulo-common';


@Component({
    selector: 'esp-description-and-keywords',
    templateUrl: './description-and-keywords.component.html',
    styleUrls: ['./description-and-keywords.component.scss'],
    imports: [
        KeywordsComponent,
        KeywordItemComponent,
        ExpandableComponent,
        TranslateModule,
        HtmlEscapePipe
    ]
})
export class DescriptionAndKeywordsComponent implements OnInit, AfterViewInit {
    sections = {
        KEYWORDS: 'keywords',
        SUBJECTESPLORO: 'subjectEsploro',
        DESCRIPTIONABSTRACT: 'descriptionAbstract',
    };

    topicsList: string[] = [];
    keywordsList: string[] = [];

    // TODO: Skipped for migration because:
    //  This input is used in a control flow expression (e.g. `@if` or `*ngIf`)
    //  and migrating would break narrowing currently.
    @Input() description;
    readonly researchTopics = input<string[]>([]);
    readonly researchKeywords = input<string[]>([]);
    readonly sectionOrder = input([]);

    constructor() {}

    ngOnInit(): void {}

    ngAfterViewInit(): void {
        this.topicsList = this.researchTopics();
        this.keywordsList = this.researchKeywords();
        this.updateComponentsPositionIfNecessary();
    }

    updateComponentsPositionIfNecessary() {
        const orderedActiveSections = this.orderedActiveSections();
        // We got 2 lists for topics.
        // In case it not separate by the description - it should be place in one list by the order the lists from the configuration.
        const isTopicsSeparet = this.isTopicsSeparet(orderedActiveSections);
        if (!isTopicsSeparet) {
            if (!this.isDescriptionAbstractFirst(orderedActiveSections)) {
                this.topicsList = this.concatTopicList(orderedActiveSections);
                this.keywordsList = [];
            } else {
                this.keywordsList = this.concatTopicList(orderedActiveSections);
                this.topicsList = [];
            }
        } else {
            if (this.isKeywordsFirst(orderedActiveSections)) {
                this.swapTopicsAndKeywords();
            }
        }
    }

    orderedActiveSections(): string[] {
        return [...this.sectionOrder()]
            .filter((section) => section.active)
            .map((section) => section.code);
    }

    isTopicsSeparet(sectionsCode: string[]): boolean {
        return (
            sectionsCode?.length === 3 &&
            sectionsCode[1] === this.sections.DESCRIPTIONABSTRACT
        );
    }

    isDescriptionAbstractFirst(sectionsCode: string[]): boolean {
        return (
            sectionsCode?.length &&
            sectionsCode[0] === this.sections.DESCRIPTIONABSTRACT
        );
    }

    isKeywordsFirst(sectionsCode: string[]): boolean {
        return (
            sectionsCode.length > 1 &&
            sectionsCode.indexOf(this.sections.KEYWORDS) <
                sectionsCode.indexOf(this.sections.SUBJECTESPLORO)
        );
    }

    concatTopicList(sectionsCode: string[]): string[] {
        return this.isKeywordsFirst(sectionsCode)
            ? this.keywordsList.concat(this.topicsList)
            : this.topicsList.concat(this.keywordsList);
    }

    swapTopicsAndKeywords(): void {
        const tempTopics = this.topicsList;
        this.topicsList = this.keywordsList;
        this.keywordsList = tempTopics;
    }
}
